export const FLAVOR_DRIVEN_TREATS = 119; //category ID

export const TEST_INTRITASSTOREID = 491; //intritasId

export const CUSTARD_CATEGORY = 5;

export const HAND_SCOOPED_CUSTARD_CATEGORY = 7;

export const NOVELTY_CUSTARD_CATEGORY = 54;
